import ENDPOINTS, { buildUrl } from '.';

import {
  pointsBalanceResponseSchema,
  pointsLedgerResponseSchema,
  PointsBalanceResponse,
  PointsLedgerResponse,
} from '@/types/schemas';

interface BalanceParams {
  wallet_address?: string;
  [key: string]: string | number | null | undefined;
}

interface LedgerParams extends BalanceParams {
  page?: number;
  limit?: number;
}

export async function getPointsBalance(
  params: BalanceParams = {}
): Promise<PointsBalanceResponse> {
  const url = buildUrl(ENDPOINTS.pointsBalance, params);

  const response = await fetch(url, {
    credentials: 'include',
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = json?.message || json?.error || response.statusText;
    throw new Error(message);
  }

  return pointsBalanceResponseSchema.parse(json.data || json);
}

export async function getPointsLedger(
  params: LedgerParams = {}
): Promise<PointsLedgerResponse> {
  const url = buildUrl(ENDPOINTS.pointsLedger, params);

  const response = await fetch(url, {
    credentials: 'include',
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = json?.message || json?.error || response.statusText;
    throw new Error(message);
  }

  // Filter out invalid entries before Zod validation
  // Some entries may have empty/invalid type fields from backend
  if (json.data?.items) {
    json.data.items = json.data.items.filter((item: any) => {
      return item.type && item.type.trim() !== '';
    });
  }

  return pointsLedgerResponseSchema.parse(json.data);
}
